import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function CostComparisonChart() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  // Lower is better, so shorter bars for lower cost
  const data = [{
    name: 'Phoenix Landscaper',
    value: 41.87,
    color: 'bg-gradient-to-t from-emerald-500 to-emerald-400',
    highlight: true
  }, {
    name: 'Competitor A',
    value: 51.7,
    color: 'bg-red-500'
  }, {
    name: 'Competitor B',
    value: 68.4,
    color: 'bg-red-500'
  }, {
    name: 'Competitor C',
    value: 79.2,
    color: 'bg-red-500'
  }];
  return <section className="py-24 bg-slate-50" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-77">
            Cost Efficiency: Lower Is Better
          </h2>
          <p className="text-xl text-slate-600" data-id="element-78">Cost Per Lead Comparison</p>
        </div>

        <div ref={ref} className="max-w-4xl mx-auto h-96 flex items-end justify-center gap-4 md:gap-12 pb-12 border-b border-slate-200" data-id="element-79">
          {data.map((item, index) => <div key={item.name} className="flex flex-col items-center justify-end h-full w-full max-w-[120px] group" data-id="element-80">
              <div className="mb-3 text-center" data-id="element-81">
                <motion.span initial={{
              opacity: 0
            }} animate={isInView ? {
              opacity: 1
            } : {
              opacity: 0
            }} transition={{
              delay: 0.5 + index * 0.1
            }} className={`text-lg md:text-2xl font-bold ${item.highlight ? 'text-emerald-600' : 'text-red-500'}`} data-id="element-82">
                  ${item.value}
                </motion.span>
              </div>
              <motion.div initial={{
            height: 0
          }} animate={isInView ? {
            height: `${item.value / 90 * 100}%`
          } : {
            height: 0
          }} transition={{
            duration: 1,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className={`w-full rounded-t-lg ${item.color} relative group-hover:opacity-90 transition-opacity`} data-id="element-83" />
              <p className={`mt-4 text-sm md:text-base font-medium text-center ${item.highlight ? 'text-slate-900 font-bold' : 'text-slate-500'}`} data-id="element-84">
                {item.name}
              </p>
            </div>)}
        </div>
        <p className="text-center text-sm text-slate-400 mt-6" data-id="element-85">
          Lower cost per lead means better ROI
        </p>
      </div>
    </section>;
}